export default "__VITE_ASSET__DBUcnEQx__"